import {
  FlexGrid,
  FlexGridItem,
  FlexGridProps,
  LabelMedium,
  Trophy02,
  useStyletron,
} from "@mezo-org/mezo-clay"

import { LeaderboardRank } from "#/shared/types"

export default function LeaderboardTrophy({
  rank,
  ...props
}: FlexGridProps & {
  rank: LeaderboardRank
}) {
  const [css, theme] = useStyletron()
  const { rankData } = rank

  if (!rankData) return null

  const { text, color } = rankData

  return (
    <FlexGrid
      flexGridColumnCount={2}
      flexGridColumnGap="scale200"
      alignItems="center"
      className={css({
        position: "absolute",
        right: theme.sizing.scale800,
        top: theme.sizing.scale800,
      })}
      {...props}
    >
      <FlexGridItem
        height="24px"
        overrides={{ Block: { style: () => ({ flexGrow: 0, width: "auto" }) } }}
      >
        <Trophy02 color={color} size={24} />
      </FlexGridItem>
      <FlexGridItem
        overrides={{ Block: { style: () => ({ flexGrow: 0, width: "auto" }) } }}
      >
        <LabelMedium>{text}</LabelMedium>
      </FlexGridItem>
    </FlexGrid>
  )
}
